module.exports = __webpack_public_path__ + "img/icon_partc_to_partb_hover.5b2c4d76.svg";